import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconJump: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconJump"><Path d="M22 11H20.5V6.50977C16.4352 10.1894 13.44 13.7855 12.8125 18.5H17V20H7V18.5H11.2393C11.1269 15.6831 9.87561 13.0462 8.01758 11.0811C6.06474 9.01572 3.5014 7.75 1 7.75V6.25C3.99857 6.25 6.93527 7.75346 9.10742 10.0508C10.4359 11.4559 11.4967 13.1804 12.124 15.084C13.4832 11.4071 16.194 8.39666 19.3809 5.5H15V4H22V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconJump;
